import React from 'react';
import * as Utils from '../../Common/utils.js';
import './PlayerGroupPage.css'; // Tell Webpack that Button.js uses these styles

export default class PlayerStrokeItem extends React.Component {

    constructor(props) {

        super(props);

        this.state = {};

        console.info('PlayerStrokeItem - constructor called.');
    }
    

    render() {

        return (
            <div className="playerstrokeitem">

                {this.renderStrokeInfo(this.props.data)}

            </div>);


    }
    renderStrokeInfo(data) {
        let classname = "playergroupEventBox";
        if (!data){
            return (<div className="strokeitem"><div className="strokeitemnum"> </div><div className="strokeitemstatus"></div></div>);
        
        }else {
            var object = JSON.parse(data.data);
           var status = Utils.getStatusFromEvent(data).toLowerCase();

            if(status.includes("green")){
                classname +=" green";
            }else if(status.includes("sand")){
                classname +=" sand";
            }else if(status.includes("preparing")){
                classname +=" prepare blink_me";
            }else if(status.includes("ruff")){
                classname += " ruff";
            }else if(status.includes("water")){
                classname += " water";
            }else if(status.includes("result")){
                status = getStrokeResult(object.result)
            }else if(status.includes("fairway")){
                classname += " fairway";
            }


           //return (<div className = "playerEventbox">{{status}}</div>)
           // return (<div className="strokeitem"><div className="strokeitemnum">{data.strokeIndex}</div><div className="playerEventbox">{status}</div></div>);
           return (<div className={classname}><p>{status}</p></div>);

        }

    }

}


function getStatusFromEventArray(array){

    var status = "";
    var reversed = array.reverse();
    var i = 0;
    reversed.forEach(element => {
        status += getStatusFromEvent(element);
        i++;
        var lastelem = i == reversed.length;
        if (!lastelem){
            status +=", ";
        }
    });

    return status;  
    
}

function getStatusFromEvent(e){
    var v = JSON.parse(e.value);

    if (v.result == 0 || v.result){
        return getStrokeResult(v.result);
    }
    if (v.status){
        return v.status;
    }else if (v.lie){
        return getStatusLieFromEndStroke(v);
    }
    return "unknown";
}

function getStatusLieFromEndStroke(v){
    if (v.lie){
        return v.lie;
    }else
   if (v.index == 0){
       return "...";
   }

   return "...";
}

function getStrokeResult(result){
var str = "in CUP - ";
    if (result == 0){
        return "Par";
    }else if (result == 1){
        return "Bogey";
    }else if (result == 2){
        return "Double Bogey";
    }
    else if (result == 3 ){
        return "Tripple Bogey";
    } else if (result == -1){
        return "Birdie";
    }else if (result == -2){
        return "Eagle";
    }else {
        return "OTHER (" + result +")";
    }
}




// WEBPACK FOOTER //
// ./src/Components/PlayerGroupPage/PlayerStrokeItem.js